import React from 'react';
import ReactDOM from 'react-dom/client';
import { createTheme, ThemeProvider as MuiThemeProvider } from '@mui/material';
import { ThemeProvider as JssThemeProvider } from 'react-jss';
import { F5Theme } from './theme/f5';
import CssBaseline from '@mui/material/CssBaseline';
import { AppProvider } from './contexts/app';
import { QueryClientProvider } from 'react-query';
import queryClient from './lib/query-client';
import { SnackbarProvider } from 'notistack';
import { ModalProvider } from './contexts/modal';
import RouteProvider from './router/provider';
import { initDatadog } from './lib/datadog';
import Environment from './lib/environment';
import ErrorBoundary from './components/error-boundary';

initDatadog();
console.log(`build v${APP_VERSION}-${Environment.MODE}`);

// F5 is the active scheme; SurePathTheme is kept for a future scheme switch.
const theme = createTheme(F5Theme);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <MuiThemeProvider theme={theme}>
      <JssThemeProvider theme={theme}>
        <CssBaseline />
        <ErrorBoundary>
          <AppProvider>
            <QueryClientProvider client={queryClient}>
              <ModalProvider>
                <SnackbarProvider>
                  <RouteProvider />
                </SnackbarProvider>
              </ModalProvider>
            </QueryClientProvider>
          </AppProvider>
        </ErrorBoundary>
      </JssThemeProvider>
    </MuiThemeProvider>
  </React.StrictMode>
);
